module.exports = __webpack_public_path__ + "static/village_title_logo-27e1509a4b64d92909f6ab068466ac91.png";